var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_c('p',[_c('i',{staticClass:"el-icon-success",staticStyle:{"color":"green"}}),_vm._v("感谢您宝贵的反馈和建议，您的需求是我们改进的动力，"+_vm._s(_vm.sec)+"秒后自动跳转到项目列表....."),_c('img',{attrs:{"src":"image/running2.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }